import store from '../store';
import Constants from '../config/constants';
import {serviceCreateProgram, serviceGetProgram, serviceUpdateProgram,serviceDeleteProgram} from "../services/Program.service";
import EventEmitter from "../libs/Events.utils";


export const FETCH_INIT = 'FETCH_INIT_PROGRAM';
export const FETCHED = 'FETCHED_PROGRAM';
export const FETCHED_FAIL = 'FETCHED_FAIL_PROGRAM';
export const FETCHED_FILTER = 'FETCHED_FILTER_PROGRAM';
export const FETCH_NEXT = 'FETCH_NEXT_PROGRAM';
export const FILTER = 'FILTER_PROGRAM';
export const RESET_FILTER = 'RESET_FILTER_PROGRAM';
export const SET_SORTING = 'SET_SORTING_PROGRAM';
export const SET_FILTER = 'SET_FILTER_PROGRAM';
export const SET_PAGE = 'SET_PAGE_PROGRAM';
export const CHANGE_PAGE = 'CHANGE_PAGE_PROGRAM';
export const CHANGE_STATUS= 'CHANGE_STATE_PROGRAM';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_PROGRAM';
export const CREATE_DATA = 'CREATE_PROGRAM';
export const UPDATE_DATA = 'UPDATE_PROGRAM';
export const DELETE_ITEM = 'DELETE_PROGRAM';

export function actionFetchPrograms(index = 1, sorting = {}, filter = {}) {
    const request = serviceGetProgram({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}



export function actionCreatePrograms(data) {
    const request = serviceCreateProgram(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, {error: 'Saved', type: 'success'});
                dispatch({type: CREATE_DATA, payload: data.data})
            }
        })
    }
}




export function actionUpdatePrograms(data) {
    const request = serviceUpdateProgram(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                dispatch({type: UPDATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionDeletePrograms(id) {
    const request = serviceDeleteProgram({ id: id});
    return (dispatch) => {
        dispatch({type: DELETE_ITEM, payload: id})
    }
}


export function actionChangePageProgramsRequests(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}

export function actionFilterProgramsRequests(value) {
    const request = null;////serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});//dispatch function
        });
    };
}


export function actionChangeStatusProgramsRequests(id, status) {
    // const request = serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
    };
}

export function actionResetFilterProgramsRequests() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageProgramsRequests(page) {
    const stateData = store.getState().program;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchPrograms(serverPage + 1, sortingData, {query, query_data: queryData}));
        // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
    }
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}

